<script lang="ts">export let size = "24";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0)">
		<mask
			id="mask0"
			style="mask-type:luminance"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="24"
			height="24"
		>
			<path d="M24 0H0V24H24V0Z" fill="white" />
		</mask>
		<g mask="url(#mask0)">
			<path
				d="M13.4617 8.30273H14.1919C14.4942 8.30273 14.7395 8.54802 14.7395 8.85036C14.7395 9.15269 14.4942 9.39796 14.1919 9.39796H13.4617C13.1594 9.39796 12.9141 9.15269 12.9141 8.85036C12.9141 8.54802 13.1594 8.30273 13.4617 8.30273Z"
				fill="currentColor"
				stroke="currentColor"
				stroke-width="0.7"
			/>
			<path
				d="M9.30326 3.93632C9.55995 2.27564 10.9989 1 12.7301 1C13.0325 1 13.2778 1.24529 13.2778 1.54762V3.93917C14.6767 4.04328 15.2629 4.57521 16.0715 5.57775L23.3731 14.3397C23.4558 14.4381 23.5 14.5621 23.5 14.6905C23.5 16.6029 21.9441 18.1587 20.0317 18.1587C19.9233 18.1587 19.8178 18.1266 19.728 18.0667C18.155 17.0179 16.5692 16.7683 15.1702 16.548C14.5127 16.4446 13.8653 16.3426 13.2778 16.1536C13.2778 17.5234 13.6186 18.5459 13.9794 19.6283C14.353 20.7471 14.7381 21.9029 14.7381 23.4524C14.7381 23.7547 14.4928 24 14.1905 24C10.2445 24 8.30499 23.1358 6.59511 22.3728C5.10199 21.7076 3.69301 21.0794 1.04762 21.0794C0.745288 21.0794 0.5 20.8341 0.5 20.5317V14.6905C0.5 8.94903 4.40463 4.24222 9.30326 3.93632ZM1.59523 19.9927C4.13225 20.0761 5.60968 20.735 7.04005 21.3724C8.64155 22.0862 10.2944 22.8235 13.6243 22.8983C13.5473 21.7946 13.2521 20.9068 12.9412 19.9749C12.5676 18.8561 12.1825 17.7002 12.1825 16.1508V15.6141C11.3055 14.9854 10.7222 13.8821 10.7222 11.7698C10.7222 11.4675 10.9675 11.2222 11.2698 11.2222C11.5721 11.2222 11.8174 11.4675 11.8174 11.7698C11.8174 14.9115 13.0695 15.109 15.3413 15.4663C16.736 15.6859 18.463 15.9576 20.1872 17.0585C21.3608 16.9822 22.3049 16.0488 22.3976 14.8794L15.2244 6.27226C14.4714 5.33888 14.1405 5.01587 12.7301 5.01587C12.4278 5.01587 12.1825 4.77059 12.1825 4.46825V2.1587C11.1372 2.40684 10.3571 3.34806 10.3571 4.46825C10.3571 4.77059 10.1118 5.01587 9.80952 5.01587C5.28025 5.01587 1.59523 9.35618 1.59523 14.6905V19.9927Z"
				fill="currentColor"
				stroke="currentColor"
				stroke-width="0.7"
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0">
			<rect width="24" height="24" fill="white" />
		</clipPath>
	</defs>
</svg>
